
export const FIRMFLOW_NAMES = {
    CLIENT_SERVICE_SUBSCRIPTION : "Service",
    CLIENT_SERVICE_SUBSCRIPTIONS : "Services",
    CLIENT_SERVICE_SUBSCRIPTON_TASK : "Step",
    CLIENT_SERVICE_SUBSCRIPTON_TASKS : "Steps",
    SUBSCRIPTION : "Service",
    SUBSCRIPTIONS : "Services",
}
